import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';

export const AddEditEmailEventConfigForm = (strings: any, eventTypes: [], mailTypes: [], id: any): FormModel[] => {
  return [
    {
      label: strings.email_event_config_column_event_type,
      value: '',
      type: 'drop-down',
      placeholder: strings.email_event_config_column_event_type,
      field: 'eventType',
      validators: [{ check: Validators.validateMandatoryField }],
      required: true,
      responsive: { xs: 6 },
      options: eventTypes,
      disabled: id,
    },
    {
      label: strings.email_event_config_column_mail_type,
      value: '',
      type: 'drop-down',
      placeholder: strings.email_event_config_column_mail_type,
      field: 'mailType',
      validators: [{ check: Validators.validateMandatoryField }],
      required: true,
      responsive: { xs: 6 },
      options: mailTypes,
      disabled: id,
    },
    {
      label: strings.email_event_config_column_to_role_name,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.email_event_config_column_to_role_name,
      field: 'toRoleIds',
      validators: [],
      responsive: { xs: 6 },
      required: false,
      isMulti: true,
    },
    {
      label: strings.email_event_config_column_cc_role_name,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.email_event_config_column_cc_role_name,
      field: 'ccRoleIds',
      validators: [],
      responsive: { xs: 6 },
      required: false,
      isMulti: true,
    },
    {
      label: strings.email_event_config_column_to_email_address,
      value: '',
      type: 'text',
      placeholder: strings.email_event_config_column_to_email_address,
      field: 'toEmailAddresses',
      validators: [{ check: Validators.validateEmailList }],
      required: false,
      responsive: { xs: 6 },
    },
    {
      label: strings.email_event_config_column_cc_email_address,
      value: '',
      type: 'text',
      placeholder: strings.email_event_config_column_cc_email_address,
      field: 'ccEmailAddresses',
      validators: [{ check: Validators.validateEmailList }],
      required: false,
      responsive: { xs: 6 },
    },
    {
      label: strings.email_event_config_column_admin_only,
      value: false,
      type: 'checkbox',
      field: 'adminOnly',
      responsive: { xs: 6 },
      placeholder: '',
      validators: [],
      required: false,
    },
  ];
};
